import { combineReducers } from 'redux';
import {
  fetchReports,
  fetchReportsByDate,
} from '../../sagas/dashboard/actions';
import { changeCurrentRange } from '../../components/Dashboard/actions';
import { logoutButtonClick } from '../../components/Auth/actions';
import moment from 'moment-timezone';

const distanceReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[0];
  }

  if (action.type === fetchReportsByDate.done.type) {
    return action.payload.result.reports[0];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const durationReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[1];
  }

  if (action.type === fetchReportsByDate.done.type) {
    return action.payload.result.reports[1];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const fuelCostReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[2];
  }

  if (action.type === fetchReportsByDate.done.type) {
    return action.payload.result.reports[2];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const fuelConsumptionReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[3];
  }

  if (action.type === fetchReportsByDate.done.type) {
    return action.payload.result.reports[3];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const speedingReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[4];
  }

  if (action.type === fetchReportsByDate.done.type) {
    return action.payload.result.reports[4];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const corneringReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[5];
  }

  if (action.type === fetchReportsByDate.done.type) {
    return action.payload.result.reports[5];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const brakingReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[6];
  }

  if (action.type === fetchReportsByDate.done.type) {
    return action.payload.result.reports[6];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const acceleratingReport = (state = {}, action) => {
  if (action.type === fetchReports.done.type) {
    return action.payload.result.reports[7];
  }

  if (action.type === fetchReportsByDate.done.type) {
    return action.payload.result.reports[7];
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const currentRange = (
  state = [moment().subtract(29, 'days'), moment()],
  action,
) => {
  if (action.type === changeCurrentRange.type) {
    return [action.payload.From, action.payload.UpTo];
  }

  if (action.type === logoutButtonClick.type) {
    return [moment().subtract(29, 'days'), moment()];
  }

  return state;
};

export default combineReducers({
  distanceReport,
  durationReport,
  fuelConsumptionReport,
  fuelCostReport,
  speedingReport,
  corneringReport,
  brakingReport,
  acceleratingReport,
  currentRange,
});



// WEBPACK FOOTER //
// ./src/reducers/dashboard/filteredReports.js